export const ASSESTS = {
  LOGO: '/images/logo.svg',
  EYE: '/images/eye.svg',
  EYESLASH: '/images/eyeSlash.svg',
  SEARCHICON: '/images/searchIconW.svg',
  SETTINGICON: '/images/settingIcon.svg',
  INCREASE: '/images/increase.svg',
  DECREASE: '/images/decrease.svg',
  MAIL: '/images/mail.svg',
  BELL: '/images/bell.svg',
  DUMMYUSER: '/images/user.svg',
  CARRETDOWN: '/images/caretDown.svg',
  ACCOUNTSETTING: '/images/acounSettingDrp.svg',
  HELP: '/images/help.svg',
  LOGOUT: '/images/logout.svg',
  //Menu
  DASHBOARD: '/images/menu/dashboard.svg',
  NEWSLETTERS: '/images/menu/newsletters.svg',
  PROACCOUNT: '/images/menu/proAccounts.svg',
  LISTICONS: '/images/menu/listIcons.svg',
  REFERRALTRACKING: '/images/menu/referralTracking.svg',
  COMPAIGNS: '/images/menu/campaigns.svg',
  FISHINITYPROCENTER: '/images/menu/fishinityProCenter.svg',
  ACCOUNTSETTINGS: '/images/menu/accountSettings.svg',
  SPONSORESUSERS: '/images/menu/sponseredUsers.svg',
  //Dashboard
  USERS: '/images/users.svg',
  DOWNLOAD: '/images/download.svg',
  REFRESH: '/images/refresh.svg',
  SUBSCRIPTION: '/images/subscription.svg',
  USERONLINE: '/images/userOnline.svg',
  CROWN: '/images/crown.svg',
  DROPDOWN: '/images/dropdown.svg',
  SLLEFT: '/images/slLeft.svg',
  SLRIGHT: '/images/slRight.svg',
  EDITICON: '/images/editIcon.svg',
  VIEWICON: '/images/viewIcon.svg',
  SHORT: '/images/sort.svg',
  ASSENDING: '/images/assending.svg',
  DECENDING: '/images/decending.svg',
  DUMMYEMAILICON: '/images/dummyEmialIcon.svg',
  SELECTDOWN: '/images/selectDown.svg',
  TABLESHORT: '/images/caretUpDownFill.svg',
  MENUBTN: '/images/menuBtn.svg',
  SELECTARROW: '/images/selectArrow.svg',
  LEFTARROW: '/images/calLeft.svg',
  RIGHTARROW: '/images/calRIght.svg',
  DELETE: '/images/delete.svg',
  DOWNLOADBTN: '/images/downloadBtn.svg',
  USERPROFILE: '/images/dummyProfile.png',
  BANNERBG: '/images/bannerBg.png',
  CALENDER: '/images/calender.svg',
  LOCATION: '/images/location.svg',
  EMAIL: '/images/email.svg',
  LANGUAGE: '/images/language.svg',
  TIME: '/images/time.svg',
  BLOCKEDUSER: '/images/blockedUser.svg',
  REFERALS: '/images/referals.svg',
  REWARDS: '/images/rewards.svg',
  ADD: '/images/plusW.svg',
  REVIEW: '/images/reviewTick.svg',
  REJECT: '/images/reject.svg',
  THREEDOT: '/images/threeDot.svg',
  UPLOAD: '/images/upload.svg',
  LIKE: '/images/like.svg',
  SHARE: '/images/share.svg',
  FISHNITYPROCENTRETAG: '/images/fishinityProCentreTag.svg',
  LOCATINGAPPACTION: '/images/locatingAppAction.svg',
  CHECKBOXCHECKED: '/images/checkboxChecked.svg',
  CHECKBOX: '/images/checkbox.svg',
  INPUTSELECTDROPDOWN: '/images/inputSelectDropdown.svg',
  STAR: '/images/star.svg',
  FIRST: '/images/first.svg',
  SECOND: '/images/second.svg',
  THIRD: '/images/third.svg',
  CLOUDUPLOAD: '/images/cloudUpload.svg',
  FISHINGDUMMY: '/images/fishingDummy.png',
  FISH: '/images/fish.svg',
  DATE: '/images/date.svg',
  ALLUSER: '/images/allUser.svg',
  THREEDOTREFERAL: '/images/threeDotReferal.svg',
  LOCATIONGREEN: '/images/locationGreen.svg',
  LAKEDUMMY: '/images/lakeDummy.png',
  CHEVRONRIGHT: '/images/chevronRight.svg',
  BELLG: '/images/bellg.svg',
  // Map
  MAPMARKER: '/images/mapMarker.svg',
  MAPADMINDUMMY: '/images/mapAdminDummy.png',
  MAPGALLERYDUMMY: '/images/mapGalleryDummy.png',
  ADDPINMAP: '/images/addPinMap.svg',
  PREVSLIDE: '/images/prevSlide.svg',
  NEXTSLIDE: '/images/nextSlide.svg',
  EDITNEWSLETTERTEMPLATES: '/images/editNewsletterTemplates.svg',
  PICKDATE: '/images/pickDate.svg',
  TEMPLATEPREVIEWDUMMY: '/images/templatePreview.png',
  DATECARRET: '/images/dateCarret.svg',
  UNCHECKGREEN: '/images/uncheckG.svg',
  CHECKEDGREEN: '/images/checkG.svg',
  SEND: '/images/send.svg',
  UPLOADF: '/images/uploadF.svg',
  PREVIEW: '/images/preview.svg',
  SAVE: '/images/save.svg',
  CARRETDOWNSELECT: '/images/caretDownSelect.svg',
  EDIT: '/images/editUser.svg',
  ADDUSER: '/images/addUser.svg',
  CAMERA: '/images/camera.svg',
  CLOSEPOPUP: '/images/closePopup.svg',
  VIEWICONLIST: '/images/viewIconList.svg',
  APPROVEICONLIST: '/images/approveIconList.svg',
  REJECTICONLIST: '/images/rejectIconList.svg',
  DELETEICONLIST: '/images/deleteIconList.svg',
  PROMOTE: '/images/promote.svg',
  SEE: '/images/see.svg',
  MAILTAB: '/images/tabmail.svg',
  EDITCOMPAIGN: '/images/editCompaign.svg',
  CLONE: '/images/clone.svg',
  SEARCHICONUSER: '/images/searchIcon.svg',
  TABLERSEND: '/images/tablerSend.svg',

   // Notification
  CLOSE: '/images/itemHide.svg',
  COMPANY: '/images/internalChange.svg',
  
  // Content Review
  AUTHOR: '/images/author.svg',
  CONTENTTYPE: '/images/contentType.svg',
  SUBMITED: '/images/submitted.svg',
  CATEGORY: '/images/category.svg',
  CONTENTREVIEWDUMMY: '/images/contentReview.png',
  CONTENTIMAGEPLACEHOLDER: '/images/contentImagePlaceholder.png',

} as const;
